import { useState, useEffect, useCallback } from 'react';
import {
  getValueByPath,
  getValueFilterTableLife,
  sortData,
} from '../utils/sortData';

const getFileterdData = (initialData, filteredInfo, filterableColumnsKey) => {
  const init = initialData.slice();

  return Object.keys(filteredInfo).reduce((acc, key) => {
    const filteredData = acc.filter((item) => {
      if (filteredInfo[key]?.length > 0) {
        return filteredInfo[key].includes(
          filterableColumnsKey[key].name === 'stageAddressLifeCycle' ||
            filterableColumnsKey[key].name ===
              'acceptanceStatusAddressLifeCycle'
            ? getValueFilterTableLife(item, filterableColumnsKey[key].name)
            : getValueByPath(item, filterableColumnsKey[key].name)
        );
      }

      return true;
    });
    return filteredData;
  }, init);
};

const getSortedData = (initialData, sortedInfo, sortableColumnKeys) => {
  const { columnKey, order } = sortedInfo;

  return initialData
    .slice()
    .sort((a, b) => sortData(order, sortableColumnKeys[columnKey], a, b));
};

const useTableChange = ({
  initialData,
  sortableColumnKeys,
  filterableColumnKeys,
  depsToReset,
  initFilteredInfo,
  initSortedInfo,
}) => {
  const [sortedInfo, setSortedInfo] = useState(null);
  const [filteredInfo, setFilteredInfo] = useState(null);
  const [sortedData, setSortedData] = useState([]);

  const handleTableChange = useCallback((_pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  }, []);

  useEffect(() => {
    const newFilteredInfo = initFilteredInfo || filteredInfo;
    const newSortedInfo = initSortedInfo || sortedInfo;

    const isFiltered =
      newFilteredInfo && filterableColumnKeys
        ? Object.keys(newFilteredInfo).some(
            (key) => newFilteredInfo[key]?.length > 0
          )
        : false;

    const isSorted = Boolean(
      newSortedInfo?.columnKey && newSortedInfo?.order && sortableColumnKeys
    );

    const filteredData = isFiltered
      ? getFileterdData(initialData, newFilteredInfo, filterableColumnKeys)
      : initialData;

    const newSortedData = isSorted
      ? getSortedData(filteredData, newSortedInfo, sortableColumnKeys)
      : filteredData;

    setSortedData(newSortedData);
  }, [
    filteredInfo,
    filterableColumnKeys,
    sortedInfo,
    sortableColumnKeys,
    initialData,
    initFilteredInfo,
    initSortedInfo,
  ]);

  useEffect(() => {
    setSortedInfo(null);
    setFilteredInfo(null);
  }, [...depsToReset]);

  return { data: sortedData, sortedInfo, filteredInfo, handleTableChange };
};

export default useTableChange;
